module.exports = __webpack_public_path__ + "assets/keypad-sounds/beep8-d05c5a645e6e1f9b5f48586086e88110.wav";